<script setup lang="ts">
import { PBadge } from '@pokerly/ui';
</script>

<template>
    <PBadge variant="secondary" rounded class="absolute top-2 left-2"><slot></slot></PBadge>
</template>

<style scoped></style>
